export default ({ request }) => ({
  techGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/tech/goods/spec/list',
      method: 'post',
      data,
    })
  },
  techGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/tech/goods/spec/detail',
      method: 'post',
      data,
    })
  },
  techGoodsSpecDelApi(data = {}) {
    return request({
      url: '/factory/tech/goods/spec/del',
      method: 'post',
      data,
    })
  },
  techGoodsSpecAddSaveApi(data = {}) {
    return request({
      url: '/factory/tech/goods/spec/add/save',
      method: 'post',
      data,
    })
  },
  techGoodsSpecEditSaveApi(data = {}) {
    return request({
      url: '/factory/tech/goods/spec/edit/save',
      method: 'post',
      data,
    })
  },
})
